<div class="sky-club-page">
  @if (content) {
  <div>
    @if (content.title) {
    <div class="sky-club-page__header">
      <div class="sky-club-page__text">
        <h2 class="sky-club-page__title">{{ content.title }}</h2>
        <hr class="sky-club-page__line" />
      </div>
    </div>
    }

    <div class="sky-club-page__background-image"></div>

    <div class="sky-club-page__content">
      <div>
        <section>
          <hr class="sky-club-page__margin" />
        </section>
      </div>

      <div class="sky-club-page__sub-header">
        <div class="sky-club-page__icon">
          <span class="sky-club-page__sub-icon"></span>
        </div>
        <div class="sky-club-page__title-section">
          <h2 class="sky-club-page__sub-title">
            {{ content.overview.title }}
          </h2>
        </div>
      </div>

      <div class="sky-club-page__details">
        @if (content.overview.expires) {
        <div class="sky-club-page__expiry-message">
          <img class="sky-club-page__expiry-icon" alt="alert" />
          Your active Membership
          <span class="sky-club-page__expiry-date">
            Expires {{ content.overview.expiryDate }}
          </span>
        </div>
        } @if (content.checkout.error) {
        <div>
          <aura-error-message
            [content]="content.checkout.error"
          ></aura-error-message>
        </div>
        }
        <section class="sky-club-page__wrapper">
          <p
            class="sky-club-page__description"
            [innerHTML]="content.overview.description"
          ></p>
        </section>

        <section class="sky-club-page__wrapper">
          <span class="sky-club-page__fewer-details"></span>
          <span
            [innerHTML]="
              details
                ? content.overview.details.toggle.collapse
                : content.overview.details.toggle.expand
            "
            (click)="details = !details"
            class="sky-club-page__toggle"
          ></span>

          @if (details) {
          <div>
            <h2 class="sky-club-page__membership-title">
              {{ content.overview.details.title }}
            </h2>
            <ul class="sky-club-page__items">
              <li>
                <h3 class="sky-club-page__list">
                  {{ content.overview.details.memberships[0].title }}
                </h3>
                <span
                  [innerHTML]="content.overview.details.memberships[0].subtitle"
                ></span>
              </li>

              <li>
                <h3 class="sky-club-page__list">
                  {{ content.overview.details.memberships[1].title }}
                </h3>
                <span
                  [innerHTML]="content.overview.details.memberships[1].subtitle"
                ></span>
              </li>
            </ul>
          </div>
          }
        </section>

        @if (!content.isLoggedIn) {
        <section class="sky-club-page__wrapper">
          <h1
            class="sky-club-page__information"
            [innerHTML]="content.overview.information"
          ></h1>
        </section>
        }

        <section class="sky-club-page__wrapper">
          <h4 class="sky-club-page__card-title">
            {{ content.overview.card.title }}
          </h4>
          <p
            class="sky-club-page__description"
            [innerHTML]="content.overview.card.description"
          ></p>
          <p class="sky-club-page__description">
            <a
              [href]="content.overview.card.action"
              aria-label="Apply now for Delta SkyMiles Reserve American Express Card"
            >
              {{ content.overview.card.actionLabel }}
            </a>
          </p>
          <p
            class="sky-club-page__description"
            [innerHTML]="content.overview.card.disclosure"
          ></p>
        </section>

        <section class="sky-club-page__wrapper">
          <span
            class="sky-club-page__description"
            [innerHTML]="content.overview.card.support"
          ></span>
        </section>

        <section class="sky-club-page__purchase-section">
          @if (!content.checkout.showCheckout) {
          <idp-purchase-options
            [content]="content.purchase"
            [checkout]="content.checkout"
            [skeletonMetaData]="{
              loaded: content.purchase.loaded,
              error: content.purchase.error,
              disabled: content.purchase.disabled
            }"
            auraSkeletonLoader
            (addToCart)="addToCart.emit($event)"
          ></idp-purchase-options>
          } @if (content.checkout.showCheckout) {
          <idp-checkout
            [content]="content.checkout"
            (checkOut)="checkOut.emit()"
            (previousButton)="previousButton.emit()"
            (returnToSkyClub)="returnToSkyClub.emit()"
          ></idp-checkout>
          }
        </section>
      </div>
    </div>
  </div>
  }
</div>
